import request from '@/utils/request'

export function getAreaCityTree(params) {
  return request({
    url: '/client/getAreaCityTree',
    method: 'get',
    params
  })
}

export function getCampTypes(params) {
  return request({
    url: '/client/getCampTypes',
    method: 'get',
    params
  })
}

